<template lang="pug">
  .logo-container
    .logo-component(v-if="variant === 'box'")
      img.box(src="@/assets/images/icon-tick.png")
    .logo-default(v-else-if="variant == 'small'")
      img(src="@/assets/images/logo.jpg")
    .logo-default(v-else)
      img(src="@/assets/images/logo.jpg")
</template>

<style lang="scss">
  .logo-component {
    position:relative;
    float:left;
    height: $logo-height;
    width: $logo-width;
    background: $primary-dark;
    img {
      &.box {
        width:24px;
        height:auto;
      }
      position:absolute;
      left:50%;
      top:50%;
      transform: translate(-50%, -50%);
    }
  }
  .logo-default img {
    max-width:200px;
    height:auto;
  }
</style>

<script>
export default {
  props: ['variant']
}
</script>